import * as React from 'react';

import { cn } from '../../lib/utils';
export type InputColorProps = {
  backgroundColor?: string;
  textColor?: string;
};

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  backgroundColor?: string;
  textColor?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps & InputColorProps>(
  (
    {
      className,
      type,
      backgroundColor = '#fff',
      textColor = '#505050',
      ...props
    },
    ref,
  ) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        style={{
          backgroundColor,
          color: textColor,
        }}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
